<template>
  <search-body />
</template>

<script>
import AgeTechServiceDetail from "@/components/ageTechService/AgeTechServiceDetail.vue";

export default {
  name: "AgeTechService",
  components: {
    "search-body": AgeTechServiceDetail,
  },
};
</script>
